import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api';
import { GROUPS } from '../data/tournament';
import GroupStage from '../components/GroupStage';
import ThirdPlacePicker from '../components/ThirdPlacePicker';
import KnockoutBracket from '../components/KnockoutBracket';

export default function ViewBracket() {
  const { leagueId, userId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [teams, setTeams] = useState([]);
  const [league, setLeague] = useState(null);
  const [actualResults, setActualResults] = useState({});
  const [tab, setTab] = useState('groups');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      api.get(`/brackets/league/${leagueId}/user/${userId}`),
      api.get('/teams'),
      api.get(`/leagues/${leagueId}`),
      api.get('/brackets/results'),
    ]).then(([bracketRes, teamsRes, leagueRes, resultsRes]) => {
      setData(bracketRes.data);
      setTeams(teamsRes.data);
      setLeague(leagueRes.data.league);
      setActualResults(resultsRes.data || {});
    }).catch(err => {
      if (err.response?.status === 403) navigate(`/league/${leagueId}/leaderboard`);
    }).finally(() => setLoading(false));
  }, [leagueId, userId, navigate]);

  const teamsByGroup = (g) => teams.filter(t => t.group_name === g);
  const picks = data?.picks || {};

  if (loading) return <div className="loading">Loading bracket…</div>;
  if (!data) return <div className="loading">Bracket not found.</div>;

  return (
    <div className="bracket-page">
      <div className="flex-between mb-2">
        <div>
          <h1>{data.username}'s Bracket</h1>
          <p className="sub">{league?.name} · Score: {data.score} pts</p>
        </div>
        <button className="btn btn-secondary btn-sm" onClick={() => navigate(`/league/${leagueId}/leaderboard`)}>← Leaderboard</button>
      </div>

      <div className="bracket-locked-banner">
        👁 Viewing {data.username}'s read-only bracket
      </div>

      <div className="bracket-tabs">
        <button className={`bracket-tab ${tab === 'groups' ? 'active' : ''}`} onClick={() => setTab('groups')}>Group Stage</button>
        <button className={`bracket-tab ${tab === 'third' ? 'active' : ''}`} onClick={() => setTab('third')}>3rd Place Picks</button>
        <button className={`bracket-tab ${tab === 'knockout' ? 'active' : ''}`} onClick={() => setTab('knockout')}>Knockout Bracket</button>
      </div>

      {tab === 'groups' && (
        <GroupStage groups={GROUPS} teamsByGroup={teamsByGroup} picks={picks.groups || {}} onUpdate={() => {}} locked={true} />
      )}
      {tab === 'third' && (
        <ThirdPlacePicker groups={GROUPS} picks={picks} teamsByGroup={teamsByGroup} selected={picks.thirdPlaceAdvance || []} onToggle={() => {}} locked={true} />
      )}
      {tab === 'knockout' && (
        <KnockoutBracket picks={picks} teams={teams} knockout={picks.knockout || {}} onPick={() => {}} locked={true} actualResults={actualResults} />
      )}
    </div>
  );
}
